import createMountedApp from './utils/create-mounted-app';
import { INPUT_EVENT, SELECT_EVENT, CANCEL_EVENT, HIDE_EVENT } from './utils/constants';
import { addPxUnit } from './utils/format';
import { createComponent } from './utils/create-component';
import Popup from './popup';
import { computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, createElementVNode, normalizeStyle, createCommentVNode, Fragment, renderList, toDisplayString } from 'vue';
import propTypes from './utils/prop-types';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function () {};
      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var props = {
  /**
   * 面板是否可见
   */
  modelValue: propTypes["boolean"]().def(false),
  /**
   * 面板标题
   */
  title: propTypes.string(),
  /**
   * 面板选项
   */
  options: propTypes.array().re(),
  /**
   * 默认选中项
   */
  activeIndex: propTypes.number(),
  /**
   * 取消按钮文案
   */
  cancelText: propTypes.string().def('取消'),
  /**
   * 面板最高高度, 超出后可滚动
   */
  maxHeight: propTypes.oneOfType([propTypes.number(), propTypes.string()]).def(400),
  /**
   * 是否将弹出层移动至body节点
   */
  transferDom: propTypes["boolean"]().def(false),
  /**
   * 移至body的弹出层上自定义的class
   */
  popupClass: propTypes.string(),
  /**
   * 组件下方安全距离
   */
  needSafeArea: propTypes["boolean"]().def(true),
  /**
   * 是否需要遮罩
   */
  needMask: propTypes["boolean"]().def(true),
  /**
   * 是否可以点击蒙层关闭
   */
  maskCloseable: propTypes["boolean"]().def(true),
  /**
   * 控制面板唯一标识，配置之后在函数式调用时，将不会对同名面板创建多个实例
   */
  uniqueName: propTypes.oneOfType([propTypes.number(), propTypes.string(), propTypes.symbol()])
};
var emits = [INPUT_EVENT, SELECT_EVENT, CANCEL_EVENT, HIDE_EVENT];

var _createComponent = createComponent('action-sheet'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: _defineProperty({}, Popup.name, Popup),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var value = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set(val) {
        emit(INPUT_EVENT, val);
      }
    });
    var containerMaxHeight = computed(function () {
      return addPxUnit(props.maxHeight);
    });
    function onHide() {
      emit(HIDE_EVENT);
    }
    function onCancel() {
      emit(INPUT_EVENT, false);
      emit(CANCEL_EVENT);
    }
    function onSelect(option, index) {
      if (!option.disabled) {
        emit(SELECT_EVENT, option, index);
        emit(INPUT_EVENT, false);
      }
    }
    return {
      value: value,
      className: className,
      containerMaxHeight: containerMaxHeight,
      onHide: onHide,
      onCancel: onCancel,
      onSelect: onSelect
    };
  }
});

var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["innerHTML", "onClick"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_popup = resolveComponent("sp-popup");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className)
  }, [createVNode(_component_sp_popup, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.value = $event;
    }),
    transferDom: _ctx.transferDom,
    position: "bottom",
    disableScroll: "",
    popupClass: _ctx.popupClass,
    maskCloseable: _ctx.maskCloseable,
    needMask: _ctx.needMask,
    onHide: _ctx.onHide
  }, {
    "default": withCtx(function () {
      return [createElementVNode("div", {
        "class": normalizeClass(["".concat(_ctx.className, "__container"), _ctx.needSafeArea && "".concat(_ctx.className, "--safe")]),
        style: normalizeStyle({
          maxHeight: _ctx.containerMaxHeight
        })
      }, [_ctx.title ? (openBlock(), createElementBlock("div", {
        key: 0,
        "class": normalizeClass("".concat(_ctx.className, "__header"))
      }, [createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__title")),
        innerHTML: _ctx.title
      }, null, 10 /* CLASS, PROPS */, _hoisted_1)], 2 /* CLASS */)) : createCommentVNode("v-if", true), createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__body"))
      }, [createElementVNode("ul", {
        "class": normalizeClass("".concat(_ctx.className, "__options"))
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, function (item, index) {
        return openBlock(), createElementBlock("li", {
          key: item.value,
          "class": normalizeClass(["".concat(_ctx.className, "__item"), _defineProperty({}, "".concat(_ctx.className, "__item-disabled"), item.disabled), _defineProperty({}, "".concat(_ctx.className, "__item-active"), index === _ctx.activeIndex && !item.disabled)]),
          innerHTML: item.content,
          onClick: function onClick($event) {
            return _ctx.onSelect(item, index);
          }
        }, null, 10 /* CLASS, PROPS */, _hoisted_2);
      }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 2 /* CLASS */), createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__footer"))
      }, [createElementVNode("div", {
        "class": normalizeClass("".concat(_ctx.className, "__cancel")),
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.onCancel && _ctx.onCancel.apply(_ctx, arguments);
        })
      }, toDisplayString(_ctx.cancelText), 3 /* TEXT, CLASS */)], 2 /* CLASS */)], 6 /* CLASS, STYLE */)];
    }),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "transferDom", "popupClass", "maskCloseable", "needMask", "onHide"])], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/action-sheet/action-sheet.vue";

var instances = [];
script.show = function (_ref) {
  var _listeners;
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    options = _ref.options,
    _ref$activeIndex = _ref.activeIndex,
    activeIndex = _ref$activeIndex === void 0 ? -1 : _ref$activeIndex,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? '取消' : _ref$cancelText,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? 400 : _ref$maxHeight,
    _ref$needSafeArea = _ref.needSafeArea,
    needSafeArea = _ref$needSafeArea === void 0 ? false : _ref$needSafeArea,
    needMask = _ref.needMask,
    uniqueName = _ref.uniqueName,
    onHide = _ref.onHide,
    onCancel = _ref.onCancel,
    onSelected = _ref.onSelected;
  // 如果已有相同uniqueName的实例，则什么都不做
  var _iterator = _createForOfIteratorHelper(instances),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var itemUniqueName = item.vm.$propsData.uniqueName;
      if (itemUniqueName && itemUniqueName === uniqueName) {
        return;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var instance = createMountedApp(script, {
    appendToBody: true,
    propsData: {
      modelValue: true,
      title: title,
      options: options,
      activeIndex: activeIndex,
      cancelText: cancelText,
      maxHeight: maxHeight,
      needSafeArea: needSafeArea,
      needMask: needMask,
      uniqueName: uniqueName
    },
    listeners: (_listeners = {}, _defineProperty(_listeners, INPUT_EVENT, function (val) {
      instance.updatePropsData({
        modelValue: val
      });
    }), _defineProperty(_listeners, HIDE_EVENT, function () {
      if (typeof onHide === 'function') {
        onHide();
      }
      instance.app.unmount();
    }), _defineProperty(_listeners, CANCEL_EVENT, function () {
      if (typeof onCancel === 'function') {
        onCancel();
      }
    }), _defineProperty(_listeners, SELECT_EVENT, function (item, index) {
      if (typeof onSelected === 'function') {
        onSelected(item, index);
      }
    }), _listeners),
    lifecycles: {
      onBeforeUnmount: function onBeforeUnmount() {
        var index = instances.indexOf(instance);
        if (index !== -1) {
          instances.splice(index, 1);
        }
        instance.clean();
      }
    }
  });
  instances.push(instance);
  return instance.vm;
};
script.closeAll = function () {
  instances.forEach(function (instance) {
    instance.updatePropsData({
      modelValue: false
    });
  });
};
var _ActionSheet = script;

export { _ActionSheet as default };
